exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".PanelEvents__eventTitle {\n    font-size: 17px;\n    line-height: 20px;\n    padding: 10px 12px;\n    color: #818c99;\n}\n\n.PanelEvents__list {\n    padding: 10px 0 20px;\n}\n", ""]);
